"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURE_NAME = void 0;
var _features = require("../../loaders/features/features");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.jserrors;